export default {
    name: 'IntervenerSearcher',

    mixins: [],

    props: {
        intervenerType: {
            type: String,
            required: false,
            default: null
        },
        accountType: {
            type: String,
            required: false,
            default: null
        }
    },
    components: {},
    /**
     * @override
     */
    data() {
        return {
            findIntervenerIsLoading: false,
            intervenerSearchResults: []
        };
    },
    methods: {
        /**
         * búsqueda de interviniente
         * @param {String} query of search
         */
        onSearchIntervenerChange(query) {
            // const q = query.split(' ');
            const q = [];
            q[0] = query;
            this.lastSearch = q;
            this.intervenerSearchResults = [];
            if (!query) {
                this.findIntervenerIsLoading = false;
                return;
            }

            let $filter = this.intervenerType && btoa(JSON.stringify({ 'intervener_type': [{ eq: this.intervenerType }] }));
            $filter = this.accountType && this.accountType === 'J' && btoa(JSON.stringify({ 'is_minor': [{ eq: false }] }));
            this.findIntervenerIsLoading = true;
            this.$intervenersService.getSearch(JSON.stringify(q), {}, false, $filter).then(res => {
                if (this.lastSearch === q) {
                    this.intervenerSearchResults = res.data.interveners.map(intervener => {
                        const lastname2 = intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
                        intervener.displayName = `${intervener.lastname_1}${lastname2}, ${intervener.name}`;
                        intervener.displayName += intervener.document_id ? `- ${intervener.document_id}` : '';
                        return intervener;
                    });
                    this.findIntervenerIsLoading = false;
                }
            });
        },
        /**
         * búsqueda de interviniente
         * @param {Object} intervener selected
         */
        onSelectIntervener(intervener) {

            Promise.all(
                [
                    this.$intervenersService.getIntervenersByUUIId(intervener.uuid),
                    this.$intervenersService.getIntervenerLegal(intervener.uuid),
                    this.$intervenersService.getIntervenerCrs(intervener.uuid),
                    this.$intervenersService.getIntervenerFatca(intervener.uuid)
                ])
                .then(res => {
                    const existingIntervener = {};

                    existingIntervener.uuid = intervener.uuid;
                    existingIntervener.personalData = res[0].data.intervener.personal_data;
                    existingIntervener.contactData = res[0].data.intervener.contacts;
                    existingIntervener.fiscalData = res[0].data.intervener.fiscal_address;
                    existingIntervener.postalData = res[0].data.intervener.postal_addresses;
                    existingIntervener.href = res[0].data._links._self.href;

                    existingIntervener.registralesData = res[1].data.interveners_business.length
                        ? res[1].data.interveners_business[0]
                        : {};
                    existingIntervener.crsData = res[2].data.intervener_crs.length
                        ? res[2].data.intervener_crs[0]
                        : {};
                    existingIntervener.fatcaData = res[3].data.intervener_fatca.length
                        ? res[3].data.intervener_fatca[0]
                        : {};

                    this.intervenerSearchResults = [];

                    existingIntervener.registralesData = res[1].data.interveners_business.length
                        ? res[1].data.interveners_business[0]
                        : {};
                    existingIntervener.crsData = res[2].data.intervener_crs.length
                        ? res[2].data.intervener_crs[0]
                        : {};
                    existingIntervener.fatcaData = res[3].data.intervener_fatca.length
                        ? res[3].data.intervener_fatca[0]
                        : {};

                    this.$emit('select', existingIntervener);
                    this.intervenerSearchResults = [];
                });
        }
    }
};
